import { decodeHTMLEntities, getLanguageCode } from './utilities';

/**
 * Fetch product snippets
 * @param  {number[]} productNumberList
 * @param  {number} productSnippetCount
 * @param  {object} abortSignal
 * @return {Promise<Response>}
 */
export function fetchSnippetsForProductNumberList(productNumberList, productSnippetCount, abortSignal = null)
{
    return fetch('/api-snippet-' + getLanguageCode(), {
        method: 'PUT',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(
            [
                {
                    'groupId': 'productSnippets',
                    'productNumberList': productNumberList,
                    'templateQualifier': 'snippets/product-list-item',
                    'itemCount': productSnippetCount
                }
            ]
        ),
        signal: abortSignal
    });
}

/**
 * Prepare product snippets
 * @param  {HTMLElement} snippetElement
 * @param  {string} etrackerMedium
 * @return {HTMLElement}
 */
export function prepareSnippetsForDOMInsertion(snippetElement, etrackerMedium = '')
{
    const template = document.createElement('template');
    const wrapper = document.createElement('div');

    wrapper.innerHTML = snippetElement.html;

    const noscript = wrapper.querySelector('noscript.loading-lazy');

    let imageElement = null;

    if (noscript)
    {
        const temporary = document.createElement('div');

        temporary.innerHTML = noscript.textContent || noscript.innerHTML;

        imageElement = temporary.querySelector('.js-image-wrapper--has-image') ||
            temporary.querySelector('.js-image-wrapper--no-image');

        noscript.remove();
    }

    template.innerHTML = wrapper.innerHTML;

    const fragment = template.content.cloneNode(true);

    if (imageElement)
    {
        fragment.querySelector('.js-image-container').prepend(imageElement);
    }

    const oldScriptTag = fragment.querySelector('script');

    if (oldScriptTag)
    {
        const newScriptTag = document.createElement('script');

        newScriptTag.textContent = decodeHTMLEntities(oldScriptTag.textContent);

        oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
    }

    const promotionTagElement = fragment.querySelector('.js-promotion-tag');

    if (promotionTagElement)
    {
        const productNumber = Number(fragment.firstElementChild.dataset.productNumber);
        const productNumberList = promotionTagElement.dataset.productNumberList.split(',').map(Number);

        promotionTagElement.classList.toggle('hidden', !productNumberList.includes(productNumber));
    }

    if (etrackerMedium !== '')
    {
        fragment.querySelectorAll('.js-product-link').forEach(link =>
        {
            link.classList.add('js-etracker__click-element');

            link.dataset.etrackerTrackingId = link.dataset.productName;
            link.dataset.etrackerMediumName = etrackerMedium;
        });
    }

    return fragment;
}
